import { render, staticRenderFns } from "./CreateBotObject.vue?vue&type=template&id=1b965856&scoped=true"
import script from "./CreateBotObject.vue?vue&type=script&lang=js"
export * from "./CreateBotObject.vue?vue&type=script&lang=js"
import style0 from "./CreateBotObject.vue?vue&type=style&index=0&id=1b965856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b965856",
  null
  
)

export default component.exports